<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="我的折上折金币"
        right-text="使用帮助"
        left-arrow
        @click-left="goBack"
        @click-right="onClickRight"
      />
    </van-sticky>
    <div class="page">
      <div class="header">
        <div class="header-num">
          <span>{{ accountMsg.balance }}</span>
          <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
        </div>
        <div class="header-right" @click="goWithdraw">
          <p>可提现： {{ accountMsg.withdrawalAmount }} 元 ></p>
        </div>
      </div>
      <div class="deductible">
        <p>购物可抵扣 {{ accountMsg.deductionAmount }}</p>
      </div>

      <div class="sign">
        <div class="streamer-img">
          <img src="@/assets/images/gold-coin/streamer.png" alt="" />
        </div>

        <!-- <div class="sign-header">
          <span>签到领金币</span>
          <span @click="seeRule">签到规则 ></span>
        </div>

        <div class="sign-body">
          <p>
            本月已签到：<span>{{ signStatus.checkedInCount }}</span> 次，已领取
            <span>{{ signStatus.awarded }}</span> 金币
          </p>
      
          <div class="sign-img">
            <div>
              <div class="frist-step">
                <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
              </div>
            </div>
            <div>
              <div
                :class="[
                  originalClass,
                  goldStatus[0].lineActive ? activeClass : '',
                ]"
              >
                ······
              </div>
            </div>
            <div>
              <div class="second-step">
                <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
              </div>
            </div>
            <div>
              <div
                :class="[
                  originalClass,
                  goldStatus[1].lineActive ? activeClass : '',
                ]"
              >
                ······
              </div>
            </div>
            <div>
              <div class="third-step">
                <img src="@/assets/images/gold-coin/some_gold.png" alt="" />
              </div>
            </div>
            <div>
              <div
                :class="[
                  originalClass,
                  goldStatus[2].lineActive ? activeClass : '',
                ]"
              >
                ······
              </div>
            </div>
            <div class="fourth-step">
              <img src="@/assets/images/gold-coin/all_gold.png" alt="" />
            </div>
          </div>
          <div class="sign-img-explain">
            <div
              class="frist-explain"
              :class="{ active: item.textActive }"
              v-for="(item, index) in goldStatus"
              :key="index"
            >
              {{ item.explain }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="blank" ></div>
    <van-popup v-model="signShow" :close-on-click-overlay="false">
      <div class="container">
        <div class="sign-show">
          <div class="sign-text">
            <p>
              本月已签到：<span>{{ signStatus.checkedInCount }}</span> 次
            </p>
            <p>
              再签到
              {{ signStatus.nextCheckInCount - signStatus.checkedInCount }}
              次可领 <span> {{ signStatus.nextReward }} </span>金币
            </p>
          </div>
        </div>
        <div class="close">
          <van-icon name="close" @click="signShow = false" />
        </div>
      </div>
    </van-popup>
    <!-- <div class="streamer">
      <img src="@/assets/images/gold-coin/streamer.png" alt="" />
    </div> -->
    <div class="bottom">
      <div class="list-header">
        <span>折上折金币明细</span>
        <span @click="seeDetails" v-if="goldList.length > 0">查看全部 ></span>
      </div>
      <div v-if="goldList.length > 0">
        <div class="list-header" v-for="(item, index) in goldList" :key="index">
          <div class="list-detail">
            <p>{{ item.source | sourceName(item.type) }}</p>
            <p v-if="item.source === 0 || item.source === 3">
              订单号：{{ item.entityId }}
            </p>
            <p>{{ getTime(item.dateCreated) }}</p>
          </div>
          <div class="list-mun">
            <span v-if="item.type === 0" style="color: #dd2437"
              >+{{ item.count }}</span
            >
            <span v-else style="color: #8bc53f">-{{ item.count }}</span>
          </div>
        </div>
      </div>
      <div v-else class="no-content">暂无明细</div>
    </div>
  </div>
</template>

<script>
import { status, list, account } from '@/api/gold-coin'
import { parseTime } from '@/utils'
export default {
  // 来源：0-购物,1-活动,2-提现,3-退款返还金币
  filters: {
    sourceName(num, type) {
      // 购物获得折上折金币                       购物0+收入0
      // 购物使用折上折金币                       购物0+支出1
      // 参与平台活动获得折上折金币          活动1+收入0
      // 退款成功，返还金币                       退款3+收入0
      // 折上折金币提现                              提现2+支出1
      const position = [
        ['购物获得折上折金币', '购物使用折上折金币'],
        ['参与平台活动获得折上折金币'],
        ['', '折上折金币提现'],
        ['退款成功，返还金币'],
      ]

      return position[num][type]
      // switch (num) {
      //   case 0:
      //     return '购物获得折上折金币'
      //   case 1:
      //     return '参与平台活动获得折上折金币'
      //   case 2:
      //     return '折上折金币提现'
      //   case 3:
      //     return '退款成功，返还金币'
      // }
    },
  },
  data() {
    return {
      signStatus: {},
      goldList: [],
      active: 1,
      signShow: false,
      goldStatus: [
        {
          textActive: false,
          lineActive: false,
          explain: '10金币',
        },
        {
          textActive: false,
          lineActive: false,
          explain: '可领40金币',
        },
        {
          textActive: false,
          lineActive: false,
          explain: '累计签到10次 领50金币',
        },
        {
          textActive: false,
          lineActive: false,
          explain: ' 累计签到20次 领150金币',
        },
      ],
      accountMsg: {},
      originalClass: 'original',
      activeClass: 'active',
    }
  },
  created() {
    // this.getStatus()
    this.getList()
    this.getAccount()
  },
  methods: {
    getStatus() {
      status().then(({ data }) => {
        if (data.code === 200) {
          this.signStatus = data.data
          if (!this.signStatus.checkedInToday) {
            this.signShow = true
          }
          if (this.signStatus.checkedInCount >= 1) {
            this.goldStatus[0].textActive = true
          }
          console.log('签到状态', data.data)
        }
      })
    },

    getAccount() {
      account().then(({ data }) => {
        if (data.code === 200) {
          this.accountMsg = data.data
          console.log('账户信息', this.accountMsg)
        }
      })
    },
    getTime(time) {
      return parseTime(time)
    },
    getList() {
      list({ currentPage: 1, pageSize: 4 }).then(({ data }) => {
        if (data.code === 200) {
          this.goldList = data.data.dataList
          console.log('流水', this.goldList)
        }
      })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight() {
      this.$router.push({
        path: '/gold-coin/gold-explain',
      })
    },
    seeDetails() {
      this.$router.push({
        path: '/gold-coin/gold-details',
      })
    },
    goWithdraw() {
      this.$router.push({ path: '/gold-coin/withdraw' })
    },
    seeRule() {
      this.$dialog
        .alert({
          title: '每日签到规则',
          message:
            '本月内签到20次即可获得最大奖励，下个月1号00：00起，签到次数清零',
        })
        .then(() => {
          // on close
        })
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  padding: 15px 12.5px;
  background: #ff5660;
  height: 120px;
  text-align: center;
  .header {
    // padding: 10px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .header-num {
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
      font-weight: normal;
      color: #ffffff;
    }
    img {
      margin-left: 10px;
      width: 34px;
      height: 34px;
    }
  }
  .header-right {
    background: #ffeee7;
    border-radius: 15px;
   padding:5px 10px;
    height: 30px;
    p {
      margin: 0px;
      font-size: 20px;
      font-weight: normal;
      color: #e41f2d;
    }
  }
}
.sign {
  text-align: center;
  margin-top: 15px;
  padding: 12px 12.5px;
  // height: 177px;
  background: #ffe9d5;
  border-radius: 8px;
  .sign-header {
    display: flex;
    justify-content: space-between;
    color: #6a3906;
  }
  .sign-body {
    margin-top: 12px;
    background: #fff;
    padding: 12px;
    border-radius: 8px;
    p {
      margin: 0;
      font-size: 12px;
      color: #6a3906;
      span {
        font-size: 18px;
        color: #f05a24;
      }
    }

    .frist-step {
      img {
        width: 17px;
        height: 17px;
      }
    }
    .second-step {
      margin: 0 10px;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .third-step {
      margin: 0 10px;
      img {
        width: 35px;
        height: 35px;
      }
    }
    .fourth-step {
      margin-left: 10px;
      img {
        width: 45px;
        height: 45px;
      }
    }
  }
}
.original {
  font-size: 22px;
  color: gray;
}
.active {
  // font-size: 22px;
  color: #f8aa10;
}
.sign-img {
  display: flex;
  margin-top: 10px;
  align-items: center;
}
.sign-img-explain {
  display: flex;
  font-size: 12px;
  color: #6a3906;
  justify-content: space-between;
  .frist-explain {
    width: 60px;
    text-align: left;
  }
}
.streamer {
  text-align: center;
  padding-bottom: 5px;
  border-bottom: 5px solid #eeeeee;
  img {
    width: 350px;
    // height: 92px;
  }
}
.bottom {
  border-top: 5px solid #eeeeee;
  .list-header {
    display: flex;
    justify-content: space-between;
    color: #231815;
    border-bottom: 1px solid #eeeeee;
    padding: 10px 12px;
    .list-detail {
      align-items: center;
      p {
        margin: 0 0 10px 0;
        color: #666666;
      }
    }
  }
}
.list-mun {
  span {
    font-size: 18px;
  }
}

.sign-show {
  // background-color: rgba(0, 0, 0, 0.7);

  background-image: url('~@/assets/images/gold-coin/sign_log.png');
  width: 245px;
  height: 250px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  text-align: center;
  .sign-text {
    text-align: center;
    position: absolute;
    left: 0px;
    right: 0;
    bottom: 30px;
    p {
      margin: 10px 0;

      font-size: 15px;
      font-family: Hiragino Sans GB;
      font-weight: normal;
      color: #6a3906;
      span {
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #f05a24;
      }
    }
  }
}
.close {
  padding: 20px;
  text-align: center;
  font-size: 30px;
  color: #fff;
  // background-color: rgba(0, 0, 0, 0.7);
}
/deep/.van-popup {
  background-color: rgba(0, 0, 0, 0);
}
.no-content {
  text-align: center;
  padding: 20px 0;
}
.streamer-img {
  img {
    width: 320px;
  }
}
.deductible{
  text-align: left;
  font-size: 16px;
  color: #fff;
  p{
    margin:10px 0;
  }
}
.blank{
  height: 70px
}
</style>